import {
  AppBar,
  AppBarProps,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const FlexGrow = styled("div")(() => ({
  flexGrow: 1,
}));

const CoverAppBar: React.FC<AppBarProps> = ({ children, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar {...props}>
      <Toolbar
        sx={{
          paddingBottom: isMobile ? "100px" : "0px",
          paddingTop: isMobile ? "30px" : "0px",
        }}
      >
        <FlexGrow />
        {children}
      </Toolbar>
    </AppBar>
  );
};

const StyledCoverAppBar = styled(CoverAppBar)(({ theme }) => ({
  background: "white",
  [theme.breakpoints.down("sm")]: {
    /* Hidden on mobile - replaced by split FABs in BottomTabNavigation */
    display: "none",
  },
  [theme.breakpoints.up("sm")]: {
    position: "relative",
    top: "auto",
    bottom: "auto",
    marginLeft: "-24px",
    marginRight: "-24px",
    marginBottom: "-70px",
    width: "calc(100% + 48px)",
  },
}));

// Variant for multi-step wizard flows (like covers) - hidden on mobile where FABs handle navigation
export const StyledWizardAppBar = styled(CoverAppBar)(({ theme }) => ({
  background: "white",
  [theme.breakpoints.down("sm")]: {
    /* Hidden on mobile - navigation handled by split FABs in BottomTabNavigation */
    display: "none",
  },
  [theme.breakpoints.up("sm")]: {
    position: "relative",
    top: "auto",
    bottom: "auto",
    marginLeft: "-24px",
    marginRight: "-24px",
    marginBottom: "-70px",
    width: "calc(100% + 48px)",
  },
}));

export default StyledCoverAppBar;
